import { clientbookApi } from '../core/clientbook-api';

export const getProductByPosRefNum = async ({ refNum, axiosConfig = {} }) => {
  return clientbookApi.get({
    url: `/products/${refNum}`,
    query: { isPosRefNum: true },
    axiosConfig,
  });
};
